import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        position: "fixed",
        top: 120,
        ...(theme.direction === "ltr" ? { left: 40 } : { right: 40 }),
        padding: "62px 30px 0px 30px",
        fontWeight: "normal",
        letterSpacing: "0",
        borderRadius: "13px",
        backgroundColor: theme.colors.white,
        boxShadow: "0 5px 14px 0 rgba(0,0,0,0.2)",
        height: "775px",
        width: "600px",
        overflow: "auto",
        zIndex: 100,
    },

    container: {
        height: "calc(100% - 30px)",
        overflow: "scroll",
    },

    mobile_container: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        position: "fixed",
        top: 0,
        ...(theme.direction === "ltr" ? { left: 0 } : { right: 0 }),
        padding: "52px 38px 40px 38px",
        fontWeight: "normal",
        letterSpacing: "0",
        borderRadius: "13px",
        backgroundColor: theme.colors.white,
        height: "100%",
        width: "100%",
        overflow: "auto",
    },

    title: {
        fontSize: "20px",
        fontWeight: "bold",
    },

    description: {
        whiteSpace: "normal",
        width: "100%",
    },

    close_container: {
        position: "absolute",
        top: 30,
        ...(theme.direction === "ltr" ? { right: 35 } : { left: 35 }),
        width: "19px",
        height: "19px",
    },
}));

export default useStyles;
